import type { MaybeRefOrGetter } from 'vue';

import type { MonospacePolicyEntitlementResource, PolicyEntitlementAction } from '#layers/access';
import { formatTitle } from '@directus/format-title';
import { computed, toValue } from 'vue';
import { useI18n } from 'vue-i18n';

export interface UsePoliciesEntitlementTranslationsOptions {
	resource: MaybeRefOrGetter<MonospacePolicyEntitlementResource>;
	action: MaybeRefOrGetter<PolicyEntitlementAction>;
}

export function usePolicyEntitlementTranslations(options: UsePoliciesEntitlementTranslationsOptions) {
	const { t, te } = useI18n();

	const resource = computed(() => toValue(options.resource));
	const action = computed(() => toValue(options.action));

	const resourceTranslationKey = computed(() => `policy.entitlements.${resource.value.name}`);
	const entitlementTranslationKey = computed(() => `${resourceTranslationKey.value}.${action.value.name}`);
	const entitlementName = computed(() => t(`${entitlementTranslationKey.value}`,	t('policy.entitlements.action_name_fallback', { action: action.value.name })));
	const entitlementDescription = computed(() => {
		const key = `${entitlementTranslationKey.value}_explanation`;

		return te(key) ? t(key) : null;
	});
	const resourceTitleSingular = computed(() => t(`${resourceTranslationKey.value}.title`, formatTitle(resource.value.name), { plural: 1 }));
	const resourceTitlePlural = computed(() => t(`${resourceTranslationKey.value}.title`, formatTitle(resource.value.name), { plural: 2 }));

	return {
		resourceTitleSingular,
		resourceTitlePlural,
		entitlementName,
		entitlementDescription,
	};
}
